import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './EmptyPage.module.css';
import MainWrapper from '../Utils/MainWrapper';

function EmptyPage() {
  const { t } = useTranslation();

  return (
    <MainWrapper className={styles.mainWrapperEmptyPage}>
      <h2 className={styles.noDataHeader}>{t('You have no sync data stored.')}</h2>
      <h3 className={styles.noDataText}>
        {t('Sign in to Opera to start syncing, and access your bookmarks and other browser data from all your devices.')}
      </h3>
      <div className={styles.videoWrapper}>
        <iframe
          src="https://www.youtube.com/embed/5-sVF-N7mMM"
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          title="Youtube"
          allowFullScreen
        />
      </div>
    </MainWrapper>
  );
}

export default EmptyPage;
